import { useState } from "react";
import { IPublicStudioLinkPageButton } from "../models/publicStudioLinkPageModels";
import { LinkPageStrokeIcon } from "./LinkPageStrokeIcon";
import styles from "./LinkPageButton.module.scss";

interface ILinkPageButtonProps {
  item: IPublicStudioLinkPageButton;
}

/**
 * One link block on the public page: an icon tile, a left-aligned label and a trailing arrow.
 * The tint comes from the `--link-button-color` variable the page sets, so every button follows
 * the studio's chosen color without a style object per row.
 */
export const LinkPageButton = ({ item }: ILinkPageButtonProps) => {
  // The icon is usually a third-party favicon, so it is one DNS failure away from a broken
  // image. Falling back to the glyph keeps the row looking deliberate instead of damaged.
  const [iconFailed, setIconFailed] = useState(false);

  const showImage = !!item.iconUrl && !iconFailed;

  return (
    <a
      className={styles.root}
      href={item.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className={styles.root_icon} aria-hidden="true">
        {showImage ? (
          <img
            className={styles.root_icon_image}
            src={item.iconUrl!}
            alt=""
            loading="lazy"
            onError={() => setIconFailed(true)}
          />
        ) : (
          <span className={styles.root_icon_glyph}>{item.glyph}</span>
        )}
      </span>

      <span className={styles.root_label}>{item.name}</span>

      <LinkPageStrokeIcon name="arrow" className={styles.root_arrow} />
    </a>
  );
};
